<template>
  <div class="h-full w-full flex flex-col justify-between overflow-y-auto text-app-color">
    <div class="w-full max-w-300 mx-auto md:max-w-full md:pl-100 pt-35 md:pt-67 md:px-50 pb-50">
      <div class="flex items-center md:hidden text-app-color" @click="back">
        <i class="text-12 mr-10 icon-keyboard-arrow-left opacity-50" />
        <p class="text-opacity-80">Back</p>
      </div>

      <h2 class="text-app-color font-bold text-35 md:text-21">Billing</h2>

      <div class="border-b border-hover pb-20">
        <p class="font-bold mt-35">Your plan</p>
        <div class="text-15 flex items-center mt-5">
          <span>You’re currently on our {{ planName }} plan</span>
          <div v-if="isFreePlan || isTrialPlan" class="ml-5">
            <span>(</span>
            <ButtonModule
              :text="`Upgrade to ${isFreePlan ? 'PRO' : 'TEAM'} here`"
              class="text-blue-main text-15 hover:underline px-0"
              @click="upgrade"
            />
            <span>)</span>
          </div>
          .
        </div>
      </div>

      <div v-if="invoices && invoices.length">
        <p class="font-bold mt-20">Invoices</p>
        <div
          v-for="(invoce, index) in invoices"
          :key="invoce.id"
          :class="{ 'border-b border-hover': index !== invoices.length - 1}"
          class="flex items-center text-15 py-5"
        >
          <p class="flex-1">{{ parseDate(invoce.createdAt, 'MM-YYYY') }}</p>
          <p class="mr-15 md:mr-35">{{ currency(invoce.amount, invoce.currency) }} - paid</p>
          <ButtonModule
            tag="a"
            target="_blank"
            :href="invoce.url"
            :has-hover="true"
            text="view invoice"
            class="text-app-color text-15"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonModule from '@/components/shared/form-controls/ButtonModule'
import { mapGetters, mapState, mapActions, mapMutations } from 'vuex'
import { parseDate, currency } from '@/plugins/filters'

export default {
  components: { ButtonModule },

  emits: ['back'],

  computed: {
    ...mapGetters(['isFreePlan', 'isTrialPlan', 'isTeamAccount']),
    ...mapState({
      invoices: state => state.plan.invoices,
      user: state => state.profile.user,
      team: state => state.team.team
    }),

    planName () {
      return this.isTeamAccount
        ? this.isTrialPlan ? 'trial' : 'team'
        : this.isFreePlan ? 'free' : 'pro'
    }
  },

  created () {
    if (!this.invoices) this.getInvoices()
  },

  methods: {
    ...mapActions(['getInvoices']),
    ...mapMutations(['changeActiveState']),

    back () {
      this.$emit('back')
    },

    currency,
    parseDate,

    upgrade () {
      this.changeActiveState('Plans')
    }
  }
}
</script>
